'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

/**
 * Defines the options for unit serializers.
 * @category Serializers
 */

/**
 * Creates a void serializer.
 *
 * @param options - A set of options for the serializer.
 */
function unit() {
  var _options$description;
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    description: (_options$description = options.description) !== null && _options$description !== void 0 ? _options$description : 'unit',
    fixedSize: 0,
    maxSize: 0,
    serialize: () => new Uint8Array(),
    deserialize: function (_bytes) {
      let offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return [undefined, offset];
    }
  };
}
exports.unit = unit;
//# sourceMappingURL=unit.cjs.map